module.exports = __webpack_public_path__ + "img/box6-03.7538b046.png";